import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// form field
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

// progressbar
import { MatProgressBarModule } from '@angular/material/progress-bar';

// snackbar
import { MatSnackBarModule } from '@angular/material/snack-bar';

// button
import { MatButtonModule } from '@angular/material/button';

// input
import { MatInputModule } from '@angular/material/input';

// card
import { MatCardModule } from '@angular/material/card';

// angular material custom global configurations
import { MAT_FORM_FIELD_CUSTOM_OPTIONS } from './mat-modules-configs';

@NgModule({
  exports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatCardModule,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: MAT_FORM_FIELD_CUSTOM_OPTIONS },
  ]
})
export class MaterialModule { }
